import axiosInstance from 'axiosInstance';
import baseUrl from 'Base_Url/baseUrl';

class ExcelModalApi {
  constructor() {
    this.baseUrl = baseUrl;
    this.getToken = () => localStorage.getItem('token');
  }

  async getScenarioData(fileTypeId, currentFY, month = null) {
    try {
      const id =
        typeof fileTypeId === 'object' ? fileTypeId.toString() : fileTypeId;

      let url = `${this.baseUrl}/upload-file/filetype/${id}?currentFY=${currentFY}`;
      if (month) {
        url += `&month=${month}`;
      }

      const response = await axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${this.getToken()}` },
      });

      if (response.data?.status && response.data?.data?.data) {
        const rawSdoUsers = response.data?.data?.data?.sdoUsers || [];
        // Remap SDO users: use subDivision._id as the item _id so downstream
        // code sends subDivision IDs (not user IDs) to the filtered API
        const mappedSdoUsers = rawSdoUsers.map(sdo => ({
          ...sdo,
          _id: sdo.subDivision?._id || sdo._id,
          originalUserId: sdo._id,
          name: sdo.nameOfOffice || sdo.name,
        }));
        return {
          success: true,
          data: response.data?.data?.data,
          scenario: response.data?.data?.data?.scenario,
          tahsils: (mappedSdoUsers.length > 0 ? mappedSdoUsers : null) || response.data?.data?.data?.tahsils || response.data?.data?.data?.sdos || response.data?.data?.data?.sdoList || [],
          sdoUsers: mappedSdoUsers,
          availableMonths: response.data?.data?.data?.availableMonths || [],
          fileType: response.data?.data?.data?.fileType,
        };
      }
      return { success: false, error: 'Invalid response format' };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message,
      };
    }
  }

  async getExcelData(fileTypeId, currentFY, params) {
    try {
      const id =
        typeof fileTypeId === 'object' ? fileTypeId.toString() : fileTypeId;

      const queryParams = { currentFY };

      if (params.month) {
        queryParams.month = params.month;
      }

      if (params.userIds) {
        queryParams.userIds = params.userIds;
      }
      if (params.userId) {
        queryParams.userId = params.userId;
      }
      if (!params.userIds && !params.userId) {
        if (params.tahsilIds) {
          queryParams.tahsilIds = params.tahsilIds;
        } else if (params.tahsilId) {
          queryParams.tahsilId = params.tahsilId;
        }
      }
      if (params.sdoIds) {
        queryParams.sdoIds = params.sdoIds;
      } else if (params.sdoId) {
        queryParams.sdoId = params.sdoId;
      }

      const response = await axiosInstance.get(
        `${this.baseUrl}/upload-file/filetype/${id}/filtered`,
        {
          params: queryParams,
          headers: { Authorization: `Bearer ${this.getToken()}` },
        },
      );

      if (response.data?.status && response.data?.data?.data) {
        return {
          success: true,
          fileType: response.data.data.data.fileType,
          data: response.data.data.data,
          files: response.data.data.data.files || [],
          excelData: response.data.data.data.excelData,
        };
      }
      return { success: false, error: 'No data found' };
    } catch (error) {
      console.error('Error loading Excel data:', error);
      return {
        success: false,
        error: error.response?.data?.data || error.message,
      };
    }
  }

  async saveExcelData(fileId, updates, sheetName = 'Sheet1') {
    try {
      const response = await axiosInstance.put(
        `${this.baseUrl}/upload-file/${fileId}/edit-excel-data`,
        { updates, sheetName },
        {
          headers: { Authorization: `Bearer ${this.getToken()}` },
        },
      );

      if (response.data?.status) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message,
        };
      }
      return { success: false, error: response.data?.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.data || error.message,
      };
    }
  }

  async updateFileStatus(fileIds, status, rejectionComments = null) {
    try {
      const payload = {
        uploadIds: Array.isArray(fileIds) ? fileIds : [fileIds],
        status,
        ...(status === 'rejected' && { rejectionComments }),
      };

      const response = await axiosInstance.put(
        `${this.baseUrl}/upload-file/${fileIds}/status`,
        payload,
        {
          headers: { Authorization: `Bearer ${this.getToken()}` },
        },
      );

      if (response.data?.status) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.data?.message,
        };
      }
      return { success: false, error: response.data?.message };
    } catch (error) {
      let errorMessage = error.response?.data?.message || error.message;
      if (error.response?.data?.data) {
        const errData = error.response.data.data;
        if (errData.details && errData.details.details && errData.details.details.length > 0) {
          const firstDetail = errData.details.details[0];
          errorMessage = firstDetail.error || errData.message || errorMessage;
        } else if (errData.message) {
          errorMessage = errData.message;
        }
      }
      return {
        success: false,
        error: errorMessage,
      };
    }
  }

  async updateTargetRecovery(currentFY, targetValue, fileTypeId) {
    try {
      const response = await axiosInstance.post(
        `${this.baseUrl}/recovery/update_target_recovery`,
        { currentFY, targetValue: targetValue, fileTypeId },
        {
          headers: { Authorization: `Bearer ${this.getToken()}` },
        }
      );
      if (response.data?.status || response.data?.success) {
        return {
          success: true,
          data: response.data?.data,
          message: response.data?.message || 'Target updated successfully',
        };
      }
      return { success: false, error: response.data?.message || 'Update failed' };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message,
      };
    }
  }
}

export default new ExcelModalApi();
